import axios from 'axios';
import QS from 'qs';
import { message } from 'antd'

export const basciUrl = 'https://api.zeus.ipcn.cn'
export const imageUrl = `https://api.zeus.ipcn.cn/ucs/file/`;
// export const imageUrl = `http://106.14.173.165:32201/zeus/api/ucs/file/`;
// export const basciUrl = 'https://106.14.173.165:32201/zeus/api'

// export const basciUrl = 'http://localhost:42007/zeus/api'
// export const imageUrl = `http://localhost:42007/zeus/api/ucs/file/`;

// export const zeusApp = process.env.REACT_APP_ZEUS_APP || 'APP005';
// export const imageUrl = process.env.REACT_APP_IMAGE_BASE_URL || 'http://localhost:42007/zeus/api/ucs/file/';

// export const basciUrl = process.env.REACT_APP_API_URL || 'http://localhost:42007/zeus/api';
export const zeusApp = 'APP005';


const service = axios.create({
    baseURL: basciUrl
})

// 请求拦截器
service.interceptors.request.use(config => {
    const token = localStorage.getItem('userToken') || '';

    config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/json; charset=utf-8';

    config.headers['zeus-app'] = zeusApp;
    config.headers['zeus-token'] = token;

    if (config.method === 'get') {
        config.params = config.params || {};
    }
    // if (config.method === 'post' || config.method === 'put') {
    //     if (config.headers['Content-Type'].includes('application/x-www-form-urlencoded')) {
    //         config.data = QS.stringify(config.data);
    //     }else if (config.headers['Content-Type'].includes('application/json')) {
    //         config.data = JSON.stringify(config.data); // 删除这行
    //     }
    // }

    if (config.method === 'post' || config.method === 'put') {
        if (config.headers['Content-Type'].includes('application/x-www-form-urlencoded')) {
            config.data = QS.stringify(config.data);
        } else if (config.headers['Content-Type'].includes('application/json')) {
            // config.data = JSON.stringify(config.data); // 删除这行
        } else {
        }
    }

    return config
}, error => {
    return Promise.reject(error);
})

// 响应拦截器
service.interceptors.response.use(response => {

    if (response.code) {
        switch (response.data.ret) {
            case '0':
                return response.data;
            case '40100':
                message.error(response.data.msg)
                localStorage.setItem('userToken', '');
                localStorage.setItem('userName', '');
                localStorage.setItem('userId', '');
                localStorage.setItem('id', '');
                localStorage.setItem('userPhone', '');
                localStorage.setItem('userEmail', '');
                localStorage.setItem('accountName', '');
                localStorage.setItem('headImg', '');
                //未登录
                break;
            case 403:
                message.error('Token 已过期，请重新登录');
                localStorage.setItem('userToken', '');
                localStorage.setItem('userName', '');
                localStorage.setItem('userId', '');
                localStorage.setItem('id', '');
                localStorage.setItem('userPhone', '');
                localStorage.setItem('userEmail', '');
                localStorage.setItem('accountName', '');
                localStorage.setItem('headImg', '');
                break;
            default:
                message.error(response.data.msg)
                localStorage.setItem('userToken', '');
                localStorage.setItem('userName', '');
                localStorage.setItem('userId', '');
                localStorage.setItem('id', '');
                localStorage.setItem('userPhone', '');
                localStorage.setItem('userEmail', '');
                localStorage.setItem('accountName', '');
                localStorage.setItem('headImg', '');
        }
    } else {
        return response;
    }
})

export default service